import type { SearchIndex } from "algoliasearch";
import { getAlgoliaIndexName, getAlgoliaIndexNameStores, normalizedBrowseObjects } from "./helpers";
import algoliasearch from "algoliasearch";
import type { AlgoliaClient, BrowseParams } from "./types";

const APP_ID = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID || "";
const SEARCH_API_KEY = process.env.NEXT_PUBLIC_ALGOLIA_API_KEY || "";
const BROWSE_API_KEY = process.env.NEXT_PUBLIC_ALGOLIA_BROWSE_API_KEY || "";

// Cache to keep singleton instances
const clientCache = new Map<string, AlgoliaClient>();

// Get client instance from cache or create a new instance
const getOrCreateClient = (apiKey: string, indexName: string): AlgoliaClient => {
    const cacheKey = `${apiKey}-${indexName}`;

    if (!clientCache.has(cacheKey)) {
        const wrapper = new AlgoliaClientWrapper(apiKey, indexName);
        clientCache.set(cacheKey, wrapper.client);
    }

    return clientCache.get(cacheKey)!;
};

class AlgoliaClientWrapper {
    readonly client: AlgoliaClient;

    constructor(apiKey: string, indexName: string) {
        this.client = this.createAlgoliaClient(apiKey, indexName);
    }

    private createAlgoliaClient(apiKey: string, indexName: string): AlgoliaClient {
        const client = algoliasearch(APP_ID, apiKey);
        const index = client.initIndex(indexName) as SearchIndex;

        return {
            ...client,
            index,
            // Override library "browseObjects" function to normalize the response
            browseObjects: (params: BrowseParams) => normalizedBrowseObjects(index, params),
        } as AlgoliaClient;
    }
}

const getIndexName = (locale: string, mode: "products" | "stores" = "products") =>
    mode === "stores" ? getAlgoliaIndexNameStores() : getAlgoliaIndexName(locale);

const algoliaBrowse = (locale: string, API_Key = BROWSE_API_KEY) => {
    return getOrCreateClient(API_Key, getAlgoliaIndexName(locale));
};

const algoliaSearch = (locale: string) => {
    return getOrCreateClient(SEARCH_API_KEY, getAlgoliaIndexName(locale));
};

export { algoliaBrowse, algoliaSearch, getIndexName };
